import _ from 'lodash';
import React, {FC} from 'react';

import {useToggle} from '../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {ArbitraryCalendarEventParticipantModel} from '../../../models/api/visualParticipantModel';
import {ArbitraryCalendarEventParticipantsItem} from './arbitraryCalendarEventParticipantsItem';
import {
  findNumberOfParticipantsToDisplay,
  maybeRenderMoreButton,
  StyledParticipantsDiv,
} from './calendarEventParticipantsList';

/*
 * Props.
 */

interface ArbitraryCalendarEventParticipantsListProps {
  visualParticipants: ReadonlyArray<ArbitraryCalendarEventParticipantModel>;
}

/*
 * Component.
 */

export const ArbitraryCalendarEventParticipantsList: FC<ArbitraryCalendarEventParticipantsListProps> = (
  props,
) => {
  const [areParticipantsExpanded, toggleParticipantsExpanded] = useToggle(false);

  const attendees = props.visualParticipants.filter((p) => p.isAttendee);
  const numParticipantsToDisplay = findNumberOfParticipantsToDisplay(
    attendees,
    false,
    areParticipantsExpanded,
  );

  return (
    <>
      <StyledParticipantsDiv>
        {_(attendees)
          .take(numParticipantsToDisplay)
          .map((participant) => <ArbitraryCalendarEventParticipantsItem participant={participant} />)
          .value()}
      </StyledParticipantsDiv>
      {maybeRenderMoreButton(
        false,
        props.visualParticipants,
        areParticipantsExpanded,
        toggleParticipantsExpanded,
        numParticipantsToDisplay,
      )}
    </>
  );
};
